export const getAddressesSlice = (state) => state.addresses || {};

export const getAllAddresses = (state) => {
  const addresses = getAddressesSlice(state);
  return addresses.byID ? Object.values(addresses.byID) : [];
};

export const getAddressByID = (id) => (state) => state.addresses.byID[id] || {};

export const getAddressesByOwnerID = (id) => (state) =>
  state.addresses.byOwnerID[id]
    ? state.addresses.byOwnerID[id].map(
        (addressID) => state.addresses.byID[addressID],
      )
    : [];
